import { type TypeOf, z } from '@simplisafe/ewok'

export const affirmBannerSchema = z.object({
  __typename: z.literal('ContentfulAffirmBanner'),
  description: z.object({ raw: z.string() }).optional(),
  title: z.string()
})

export type AffirmBannerFragment = TypeOf<typeof affirmBannerSchema>
